import {
  RESET_PASSWORD_VERIFY_ACCOUNT_BEGIN,
  RESET_PASSWORD_VERIFY_ACCOUNT_SUCCESS,
  RESET_PASSWORD_VERIFY_ACCOUNT_ERROR,
} from './constants';
import {BFFAgent} from '../../../common/BFFAgent';

export function verifyAccount(dni, email) {
  return async (dispatch) => {

    dispatch({
      type: RESET_PASSWORD_VERIFY_ACCOUNT_BEGIN,
    })

    try{
      const response = await BFFAgent.User.verifyRestorePassword(dni, email);
      if(response.success) {
        dispatch({
          type: RESET_PASSWORD_VERIFY_ACCOUNT_SUCCESS
        })
      } else {
        dispatch({
          type: RESET_PASSWORD_VERIFY_ACCOUNT_ERROR
        })
      }

    } catch(error){
      dispatch({
        type: RESET_PASSWORD_VERIFY_ACCOUNT_ERROR
      })
    } 
  }
}

export function reducer(state, action) {
  switch (action.type) {
    case RESET_PASSWORD_VERIFY_ACCOUNT_BEGIN:
      return {
        ...state,
        verifyAccountPending: true,
      }
    case RESET_PASSWORD_VERIFY_ACCOUNT_SUCCESS:
      return {
        ...state,
        verifyAccountSuccess: true,
        verifyAccountPending: false,
        verifyAccountError: false,
      }
    case RESET_PASSWORD_VERIFY_ACCOUNT_ERROR:
      return {
        ...state,
        verifyAccountError: true,
        verifyAccountPending: false,
      }

    default:
      return state
  }
}